import * as React from 'react';
import { DateLabel } from './date-label';

export const BatchInfoLabel = (props: {prefix: string, name: string, date: Date, isOnClosedListing: boolean}) => {
	const { prefix, name, date, isOnClosedListing } = props;
	return <span>{prefix} {name} <DateLabel date={date} /> {isOnClosedListing ? '(Listing Closed)' : ''}</span>;
};
